var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("\n    "+_vm._s(_vm.item.id)+"\n  ")]),_c('td',[_vm._v("\n    "+_vm._s(_vm.item.name)+"\n  ")]),_c('td',[_vm._v("\n    "+_vm._s(_vm.item.distance)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }